import { useAdminStore } from '@getmayday/vue-modules';

const useExternalRedirection = () => {
  const adminStore = useAdminStore();
  const { accessToken, subdomainUrl, company } = storeToRefs(adminStore);

  const frontUrl = computed(() => {
    if (company.value?.subdomain === 'app' || !subdomainUrl.value)
      return import.meta.env.VITE_APP_FRONT_URL as string;
    return subdomainUrl.value;
  });

  function webUrl(path: string) {
    return new URL(path, frontUrl.value).href;
  }

  const entityUrl = ({
    entityId,
    entityType,
    knowledgeId,
    lang,
  }: {
    entityId: string;
    entityType: string;
    knowledgeId?: string;
    lang: string;
  }) => {
    const type = !entityType || entityType === 'Case' ? 'cases' : 'contents';

    if (knowledgeId) {
      return `/desk/${lang}/knowledges/${knowledgeId}/${type}/${entityId}`;
    }

    return `/desk/${lang}/${type}/${entityId}`;
  };

  function redirectUrl(url: string) {
    if (accessToken.value === null) return null;

    const redirectUrl = new URL(url, frontUrl.value);
    redirectUrl.searchParams.set('token', accessToken.value);

    return redirectUrl.href;
  }

  return { redirectUrl, webUrl, entityUrl };
};

export default useExternalRedirection;
